import { MapPin, Phone, Navigation } from "lucide-react";
import { CLINIC } from "@/lib/api";

const HOURS = [["Mon – Sat", "10 AM – 1 PM · 5 PM – 9 PM"], ["Sunday", "Closed"]];

export const Contact = () => (
  <section id="contact" className="mx-auto max-w-7xl px-6 py-20 lg:px-8" data-testid="contact-section">
    <div className="grid overflow-hidden rounded-[2.5rem] border-2 border-slate-800/5 bg-white lg:grid-cols-2">
      <div className="p-8 sm:p-12">
        <span className="text-xs font-bold uppercase tracking-widest text-teal-600">Come say hi</span>
        <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">Find Tooth Buds</h2>
        <p className="mt-6 flex gap-3 text-slate-600"><MapPin className="mt-1 h-5 w-5 shrink-0 text-[#ff6b6b]" />{CLINIC.address}</p>
        <div className="mt-6 space-y-2">
          {HOURS.map(([d, h]) => (
            <div key={d} className="flex justify-between rounded-xl bg-[#fffdf9] px-4 py-3 text-sm">
              <span className="font-bold text-slate-700">{d}</span><span className="text-slate-600">{h}</span>
            </div>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href={`tel:${CLINIC.phoneRaw}`} data-testid="contact-call-button"
            className="btn-pop inline-flex items-center gap-2 rounded-full bg-teal-600 px-6 py-3 text-sm font-bold text-white"><Phone className="h-4 w-4" />{CLINIC.phone}</a>
          <a href={CLINIC.maps} target="_blank" rel="noreferrer" data-testid="contact-directions-button"
            className="btn-pop inline-flex items-center gap-2 rounded-full border-2 border-slate-800 px-6 py-3 text-sm font-bold text-slate-800"><Navigation className="h-4 w-4" />Directions</a>
        </div>
      </div>
      <iframe title="Tooth Buds on Google Maps" src={CLINIC.mapEmbed} className="h-80 w-full border-0 lg:h-full" loading="lazy" data-testid="contact-map" />
    </div>
  </section>
);
